<template>
    <div>
        <el-dialog title="Szczegóły widgetu"
                   :before-close="handleClose"
                   width="80vw"
                   :visible.sync="dialogFormVisible">
            <div class="language-switcher">
                <form-language-switcher/>
            </div>
            <el-form :model="formCopy"
                     label-width="100px">
                <div v-if="widgetType.global">
                    <el-form-item label="Widget">
                        <el-select filterable
                                   v-model="formCopy.id"
                                   @change="globalWidgetSet"
                                   placeholder="Wybierz widget">
                            <el-option v-for="widget in availableWidgets"
                                       :key="widget.id"
                                       :label="widget.name_pl"
                                       :value="widget.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div v-else>
                    <base-widget :form.sync="formCopy"
                                 :errors="errors"/>
                    <component :is="widgetComponent"
                               :form.sync="formCopy"
                               :errors="errors"/>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelForm()">Anuluj</el-button>
                <el-button type="primary"
                           @click="submitForm()">Zatwierdź
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import BaseWidget from '@/components/widgets/forms/BaseWidget'
    import {Widget} from '@/api'

    export default {
        props: ["widget", "bus"],
        data () {
            return {
                formCopy: {},
                originalForm: {},
                widgetComponent: null,
                errors: {},
                dialogFormVisible: false
            }
        },
        computed: {
            widgetType () {
                const typeFilter = type => type['resourcetype'] === this.formCopy.resourcetype
                const foundType = Object.values(this.$store.state.idBasedWidgetTypes).find(typeFilter)
                if (foundType) {
                    return foundType
                }
                return {}
            },
            availableWidgets () {
                if (this.formCopy.resourcetype) {
                    const ctype = this.widgetType['polymorphic_ctype']
                    return this.$store.state.availableWidgets[ctype]
                }
                return []
            }
        },
        mounted () {
            this.bus.$on('openWidgetDialog', this.openDialog)
        },
        watch: {
            dialogFormVisible (value) {
                if (!value) {
                    this.widgetComponent = null
                }
            }
        },
        methods: {
            openDialog (widget, errors) {
                this.formCopy = JSON.parse(JSON.stringify(widget))
                this.originalForm = widget  // keep reference
                this.widgetComponent = this.getWidgetComponent(widget.resourcetype)
                this.dialogFormVisible = true
                this.errors = errors || {}
            },
            globalWidgetSet (e) {
                const widget = this.availableWidgets.find(widget => widget.id === e)
                if (widget) {
                    this.$set(this, 'formCopy', {
                        name_pl: widget.name_pl,
                        id: widget.id,
                        resourcetype: this.formCopy.resourcetype
                    })
                }
            },
            handleClose (done) {
                const formWasChanged = JSON.stringify(this.formCopy) !== JSON.stringify(this.originalForm)
                if (formWasChanged) {
                    this.$confirm('Zmiany zostaną utracone.')
                        .then(response => {
                            done();
                        })
                        .catch(_ => {
                        });
                } else {
                    done()
                }
            },
            cancelForm () {
                this.dialogFormVisible = false
                this.$emit('cancel')
            },
            submitForm () {
                Widget.validate(this.formCopy).then(response => {
                    this.$emit('submit', this.formCopy, this.originalForm)
                    this.dialogFormVisible = false
                }).catch(this.errorHandler)
            }
        },
        components: {
            BaseWidget
        }
    }
</script>
<style lang="scss" scoped>
    .language-switcher {
        text-align: right;
        position: relative;
        bottom: 57px;
        right: 45px;
    }
</style>


// WEBPACK FOOTER //
// WidgetDialog.vue?f548d3ae